import React from 'react';
import PropTypes from 'prop-types';
import getHTMLElement from '../lib/setHtmlHelper';

export default class LegalFooter extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const legalContent = this.props.legalFooter;
    const innerHtml =  getHTMLElement(legalContent, {useHTML: true });
    const fontChange = this.props.country === 'vn' && this.props.locale === 'vi_VN' ? 'vnFont' : this.props.country === 'jp' && this.props.locale === 'ja_JP'? 'jpFont': '';
    if(legalContent){
        return(
            <div className={`legalFooter ${fontChange}`}>
                <section className="LegalContent">{innerHtml}</section>
            </div>
        );
    }
    else{
        return null;
    }
  }
}

LegalFooter.propTypes = {
  articleInfo: PropTypes.shape({
    content: PropTypes.shape({
      footer: PropTypes.string
    })
  })
};
